'use client'

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { Badge } from '@/components/ui/badge'
import { motion } from 'framer-motion'
import { X } from 'lucide-react'
import { Button } from './ui/button'

export default function PersonDetailModal({ person, onClose }) {
    if (!person) return null;

    const initials = person.name.substring(0, 2);
    const isFoo = person.id.startsWith('foo');

    return (
        <Dialog open={!!person} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader className="flex flex-row items-center justify-between">
                    <DialogTitle>Person Details</DialogTitle>
                    <Button
                        variant="ghost"
                        size="icon"
                        className="h-12 w-12 p-0 hover:bg-gray-100 rounded-full"
                        onClick={onClose}
                    >
                        <X className="h-8 w-8" />
                        <span className="sr-only">Close</span>
                    </Button>
                </DialogHeader>

                <div className="py-4">
                    <div className="flex items-center gap-4 mb-6">
                        <Avatar className="h-16 w-16 border-2 border-primary">
                            <AvatarFallback className="text-lg">{initials}</AvatarFallback>
                        </Avatar>
                        <div>
                            <div className="flex items-center gap-2 mb-1">
                                <h2 className="text-xl font-bold">{person.name}</h2>
                                {isFoo ? (
                                    <Badge>Foo</Badge>
                                ) : (
                                    <Badge variant="secondary">Doe</Badge>
                                )}
                            </div>
                            <p className="text-md text-foreground">"{person.tag}"</p>
                        </div>
                    </div>

                    <Tabs defaultValue="profile">
                        <TabsList className="grid w-full grid-cols-1">
                            <TabsTrigger value="profile">Profile</TabsTrigger>
                        </TabsList>

                        <TabsContent value="profile" className="space-y-4 pt-4">
                            <div className="grid grid-cols-2 gap-4">
                                {person.profile && Object.entries(person.profile).map(([key, value]) => (
                                    <motion.div
                                        key={key}
                                        initial={{ opacity: 0, y: 10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        className="p-3 rounded-md bg-muted"
                                    >
                                        <div className="text-xs text-muted-foreground uppercase">{key}</div>
                                        <div className="font-medium">{value}</div>
                                    </motion.div>
                                ))}
                            </div>
                        </TabsContent>
                    </Tabs>
                </div>
            </DialogContent>
        </Dialog>
    );
} 